import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { deliveryMethodNames as deliveryMethodLabels } from '@reveni-io/reveni-ui'

import { filterDeliveryMethods } from './helpers'

const useFilter = deliveryMethods => {
  const [filters, setFilters] = useState({})
  const { t } = useTranslation()

  const filteredDeliveryMethods = useMemo(() => {
    return filterDeliveryMethods(deliveryMethods, filters, t, deliveryMethodLabels)
  }, [deliveryMethods, filters, t])

  return {
    filteredDeliveryMethods,
    filters,
    setFilters,
  }
}

export default useFilter
